import { createToolbarEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { MEET_FEATURES } from '../../base/jwt/constants';
import { isLocalParticipantModerator } from '../../base/participants';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { maybeShowPremiumFeatureDialog } from '../../jaas/actions';
import { onCaption } from '../../live-caption/functions';
import { setStreamStatus } from '../../live-caption/slice';
import { NOTIFICATION_TIMEOUT_TYPE, showWarningNotification } from '../../notifications';
import { setEnableSubtitle } from '../actions.any';
import { canStartSubtitles } from '../functions.any';
/**
 * The button component which starts/stops the transcription.
 */
export class AbstractClosedCaptionButton extends AbstractButton {
    /**
     * Helper function to be implemented by subclasses, which should be used
     * to handle the closed caption button being clicked / pressed.
     *
     * @protected
     * @returns {void}
     */
    _handleClickOpenLanguageSelector() {
        // To be implemented by subclass.
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _requestingSubtitles, dispatch, streamStatus, liveCaptionEnabled, isLocalModerator, enableSubtitle, transcription } = this.props;
        if (transcription?.oldType) {
            sendAnalytics(createToolbarEvent('transcribing.ccButton', {
                'requesting_subtitles': Boolean(_requestingSubtitles)
            }));
            const dialogShown = dispatch(maybeShowPremiumFeatureDialog(MEET_FEATURES.RECORDING));
            if (!dialogShown) {
                this._handleClickOpenLanguageSelector();
            }
        }
        else {
            dispatch(setStreamStatus(streamStatus === 'started' ? 'stopped' : 'started'));
            if (isLocalModerator) {
                if (!enableSubtitle) {
                    webSocket.emit("enable_live_caption_room_client", true);
                    dispatch(setEnableSubtitle(true));
                }
                dispatch(onCaption(!liveCaptionEnabled));
            }
            else {
                webSocket.emit("check_live_caption_room_client", true);
                if (enableSubtitle) {
                    dispatch(onCaption(!liveCaptionEnabled));
                }
                else {
                    // thong bao ban khong co quyen bat live caption
                    dispatch(showWarningNotification({
                        titleKey: 'notify.warningLiveCaptionPermissionTitle',
                        descriptionKey: 'notify.warningLiveCaptionPermissionDescription'
                    }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                }
            }
        }
    }
    /**
     * Indicates whether this button is disabled or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return false;
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        // return this.props._requestingSubtitles;
        return this.props.liveCaptionEnabled;
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code AbstractClosedCaptionButton} component.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component
 * instance.
 * @private
 * @returns {{
 *     _requestingSubtitles: boolean,
 *     _language: string,
 *     visible: boolean
 * }}
 */
export function _abstractMapStateToProps(state, ownProps) {
    const { _requestingSubtitles, _language, enableSubtitle } = state['features/subtitles'];
    const { streamStatus, enabled } = state['features/live-caption'];
    const { transcription } = state['features/base/config'];
    const isLocalModerator = isLocalParticipantModerator(state);
    // if the participant is moderator, it can enable transcriptions and if
    // transcriptions are already started for the meeting, guests can just show them
    const { visible = canStartSubtitles(state) } = ownProps;
    // const visible = true;
    return {
        _requestingSubtitles,
        _language,
        visible,
        streamStatus,
        liveCaptionEnabled: enabled,
        isLocalModerator,
        enableSubtitle,
        customId: 'item-closed-caption',
        transcription
    };
}
